module.exports = __webpack_public_path__ + "assets/img/1523a5c8fca3f6bdeb17efed8472d147.png";